import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=f0e34990&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=f0e34990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e34990",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0e34990')) {
      api.createRecord('f0e34990', component.options)
    } else {
      api.reload('f0e34990', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=f0e34990&scoped=true&", function () {
      api.rerender('f0e34990', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4pEkAqf7UlD84/JS/comp/CookieBox.vue"
export default component.exports